import React from "react";
import InfoCard from "../Layout/DesignSystem/InfoCard/InfoCard";
import "./Statistics.css";

const Statistics = ({ statistics }) => {
  return (
    <div className="statistics-container">
      {statistics.map((statistic, index) => (
        <div className="statistics-card-wrapper" key={index}>
          <InfoCard statistic={statistic} />
        </div>
      ))}
    </div>
  );
};

export default Statistics;
